/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './tags-input.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/common';
import * as i3 from '@angular/forms';
import * as i4 from 'ngx-bootstrap/typeahead/typeahead.directive';
import * as i5 from 'ngx-bootstrap/component-loader/component-loader.factory';
import * as i6 from '../../../../app/common/tags-input/tags-input.component';
const styles_AppTagsInputComponent:any[] = [i0.styles];
export const RenderType_AppTagsInputComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_AppTagsInputComponent,data:{}});
function View_AppTagsInputComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),7,'span',[['class',
      'tags-input__tag-remove-btn'],['role','button']],(null as any),[[(null as any),
      'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.removeTag((<any>_v.parent).context.$implicit)) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n            '])),
      (_l()(),i1.ɵeld(2,0,(null as any),(null as any),1,'span',[['aria-hidden','true']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['×'])),(_l()(),i1.ɵted(-1,(null as any),['\n            '])),
      (_l()(),i1.ɵeld(5,0,(null as any),(null as any),1,'span',[['class','sr-only']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['Close'])),(_l()(),i1.ɵted(-1,(null as any),
          ['\n        ']))],(null as any),(null as any));
}
function View_AppTagsInputComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),4,'span',[['class',
      'tags-input__tag label label-primary']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i1.ɵted(1,(null as any),['\n        ',
      '\n        '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_AppTagsInputComponent_2)),i1.ɵdid(3,16384,(null as any),0,i2.NgIf,[i1.ViewContainerRef,
      i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),
      ['\n    ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_1:any = _co.isDeleteable(_v.context.$implicit);
    _ck(_v,3,0,currVal_1);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _v.context.$implicit[_co.displayField];
    _ck(_v,1,0,currVal_0);
  });
}
function View_AppTagsInputComponent_3(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,[['tagInput',1]],(null as any),0,'input',[['class',
      'tags-input__input-field'],['name','tags'],['type','text']],[[8,'placeholder',
      0],[8,'disabled',0],[8,'hidden',0]],[[(null as any),'keyup.enter'],[(null as any),
      'keydown.backspace']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('keyup.enter' === en)) {
      const pd_0:any = ((<any>_co.addTag(i1.ɵnov(_v,0))) !== false);
      ad = (pd_0 && ad);
    }
    if (('keydown.backspace' === en)) {
      const pd_1:any = ((<any>_co.removeLastTag(i1.ɵnov(_v,0))) !== false);
      ad = (pd_1 && ad);
    }
    return ad;
  },(null as any),(null as any)))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = i1.ɵinlineInterpolate(1,'',_co.getPlaceHolder(),'');
    const currVal_1:any = _co.maximumOfTagsReached();
    const currVal_2:any = _co.maximumOfTagsReached();
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2);
  });
}
function View_AppTagsInputComponent_4(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,16777216,[['tagInput',1]],(null as any),6,'input',
      [['class','tags-input__input-field'],['name','tags'],['type','text']],[[8,'placeholder',
          0],[8,'hidden',0],[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],
          [2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',
              (null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],
      [[(null as any),'keydown.backspace'],[(null as any),'ngModelChange'],[(null as any),
          'typeaheadOnSelect'],[(null as any),'typeaheadNoResults'],[(null as any),
          'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
          'compositionend'],[(null as any),'keyup'],[(null as any),'click'],[(null as any),
          'focus'],[(null as any),'keydown']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('input' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,1)._handleInput($event.target.value)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,1).onTouched()) !== false);
          ad = (pd_1 && ad);
        }
        if (('compositionstart' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,1)._compositionStart()) !== false);
          ad = (pd_2 && ad);
        }
        if (('compositionend' === en)) {
          const pd_3:any = ((<any>i1.ɵnov(_v,1)._compositionEnd($event.target.value)) !== false);
          ad = (pd_3 && ad);
        }
        if (('input' === en)) {
          const pd_4:any = ((<any>i1.ɵnov(_v,6).onInput($event)) !== false);
          ad = (pd_4 && ad);
        }
        if (('keyup' === en)) {
          const pd_5:any = ((<any>i1.ɵnov(_v,6).onChange($event)) !== false);
          ad = (pd_5 && ad);
        }
        if (('click' === en)) {
          const pd_6:any = ((<any>i1.ɵnov(_v,6).onFocus()) !== false);
          ad = (pd_6 && ad);
        }
        if (('focus' === en)) {
          const pd_7:any = ((<any>i1.ɵnov(_v,6).onFocus()) !== false);
          ad = (pd_7 && ad);
        }
        if (('blur' === en)) {
          const pd_8:any = ((<any>i1.ɵnov(_v,6).onBlur()) !== false);
          ad = (pd_8 && ad);
        }
        if (('keydown' === en)) {
          const pd_9:any = ((<any>i1.ɵnov(_v,6).onKeydown($event)) !== false);
          ad = (pd_9 && ad);
        }
        if (('keydown.backspace' === en)) {
          const pd_10:any = ((<any>_co.removeLastTag(i1.ɵnov(_v,0))) !== false);
          ad = (pd_10 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_11:any = ((<any>(_co.selected = $event)) !== false);
          ad = (pd_11 && ad);
        }
        if (('typeaheadOnSelect' === en)) {
          const pd_12:any = ((<any>_co.typeaheadOnSelect($event)) !== false);
          ad = (pd_12 && ad);
        }
        if (('typeaheadNoResults' === en)) {
          const pd_13:any = ((<any>_co.typeaheadOnNoMatch($event)) !== false);
          ad = (pd_13 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(1,16384,(null as any),0,i3.DefaultValueAccessor,
      [i1.Renderer2,i1.ElementRef,[2,i3.COMPOSITION_BUFFER_MODE]],(null as any),(null as any)),
      i1.ɵprd(1024,(null as any),i3.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i3.DefaultValueAccessor]),i1.ɵdid(3,671744,(null as any),0,i3.NgModel,[[8,
          (null as any)],[8,(null as any)],[8,(null as any)],[2,i3.NG_VALUE_ACCESSOR]],
          {name:[0,'name'],isDisabled:[1,'isDisabled'],model:[2,'model']},{update:'ngModelChange'}),
      i1.ɵprd(2048,(null as any),i3.NgControl,(null as any),[i3.NgModel]),i1.ɵdid(5,
          16384,(null as any),0,i3.NgControlStatus,[i3.NgControl],(null as any),(null as any)),
      i1.ɵdid(6,212992,(null as any),0,i4.TypeaheadDirective,[i3.NgControl,i1.ElementRef,
          i1.ViewContainerRef,i1.Renderer2,i5.ComponentLoaderFactory,i1.ChangeDetectorRef],
          {typeahead:[0,'typeahead'],typeaheadOptionField:[1,'typeaheadOptionField']},
          {typeaheadNoResults:'typeaheadNoResults',typeaheadOnSelect:'typeaheadOnSelect'}),
      (_l()(),i1.ɵand(0,(null as any),(null as any),0))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_9:any = 'tags';
    const currVal_10:any = _co.maximumOfTagsReached();
    const currVal_11:any = _co.selected;
    _ck(_v,3,0,currVal_9,currVal_10,currVal_11);
    const currVal_12:any = _co.options;
    const currVal_13:any = _co.displayField;
    _ck(_v,6,0,currVal_12,currVal_13);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = i1.ɵinlineInterpolate(1,'',_co.getPlaceHolder(),'');
    const currVal_1:any = _co.maximumOfTagsReached();
    const currVal_2:any = i1.ɵnov(_v,5).ngClassUntouched;
    const currVal_3:any = i1.ɵnov(_v,5).ngClassTouched;
    const currVal_4:any = i1.ɵnov(_v,5).ngClassPristine;
    const currVal_5:any = i1.ɵnov(_v,5).ngClassDirty;
    const currVal_6:any = i1.ɵnov(_v,5).ngClassValid;
    const currVal_7:any = i1.ɵnov(_v,5).ngClassInvalid;
    const currVal_8:any = i1.ɵnov(_v,5).ngClassPending;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
        currVal_7,currVal_8);
  });
}
export function View_AppTagsInputComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),10,'div',[['class',
      'tags-input']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_AppTagsInputComponent_1)),i1.ɵdid(3,802816,
          (null as any),0,i2.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,i1.IterableDiffers],
          {ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),
          ['\n    '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
          View_AppTagsInputComponent_3)),i1.ɵdid(6,16384,(null as any),0,i2.NgIf,[i1.ViewContainerRef,
          i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),
          ['\n    '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
          View_AppTagsInputComponent_4)),i1.ɵdid(9,16384,(null as any),0,i2.NgIf,[i1.ViewContainerRef,
          i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),
          ['\n'])),(_l()(),i1.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    var _co:i6.AppTagsInputComponent = _v.component;
    const currVal_0:any = _co.tags;
    _ck(_v,3,0,currVal_0);
    const currVal_1:any = (_co.options === (null as any));
    _ck(_v,6,0,currVal_1);
    const currVal_2:any = (_co.options !== (null as any));
    _ck(_v,9,0,currVal_2);
  },(null as any));
}
export function View_AppTagsInputComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),2,'app-tags-input',
      ([] as any[]),(null as any),(null as any),(null as any),View_AppTagsInputComponent_0,
      RenderType_AppTagsInputComponent)),i1.ɵprd(5120,(null as any),i3.NG_VALUE_ACCESSOR,
      (p0_0:any) => {
        return [p0_0];
      },[i6.AppTagsInputComponent]),i1.ɵdid(2,114688,(null as any),0,i6.AppTagsInputComponent,
      ([] as any[]),(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,2,0);
  },(null as any));
}
export const AppTagsInputComponentNgFactory:i1.ComponentFactory<i6.AppTagsInputComponent> = i1.ɵccf('app-tags-input',
    i6.AppTagsInputComponent,View_AppTagsInputComponent_Host_0,{maxTags:'maxTags',
        removeLastOnBackspace:'removeLastOnBackspace',canDeleteTags:'canDeleteTags',
        placeholder:'placeholder',options:'options',displayField:'displayField'},{onTagsChanged:'onTagsChanged',
        onMaxTagsReached:'onMaxTagsReached',onNoOptionsMatch:'onNoOptionsMatch'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/$$_gendir/app/common/tags-input/tags-input.component.ngfactory.ts